import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';
import type { StudentNoteItem } from '@/types/dashboard';
import { formatDateTime } from '@/lib/utils';

interface NotesListProps {
  notes: StudentNoteItem[];
  onDelete: (noteId: string) => void;
  isDeleting: boolean;
}

export function NotesList({ notes, onDelete, isDeleting }: NotesListProps) {
  if (notes.length === 0) {
    return <p className="text-sm text-muted-foreground">No notes yet.</p>;
  }

  return (
    <div className="space-y-3">
      {notes.map((note) => (
        <Card key={note.id}>
          <CardContent className="flex items-start justify-between gap-4 pt-4">
            <div className="flex-1">
              <p className="whitespace-pre-wrap text-sm">{note.body}</p>
              <p className="mt-1 text-xs text-muted-foreground">
                {formatDateTime(note.created_at)}
              </p>
            </div>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => onDelete(note.id)}
              disabled={isDeleting}
            >
              <Trash2 className="h-4 w-4 text-destructive" />
            </Button>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
